import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Flex } from 'reflexbox'
import { IconButton } from 'react-toolbox/lib/button'
import { IconMenu, MenuItem } from 'react-toolbox/lib/menu'
import * as R from 'ramda'

const formatMenuItem = (value, onClick) => (
  <MenuItem
    key={value}
    onClick={() => onClick(value)}
    value={value}
    caption={`${value}`}
  />
)

const getMenuItem = (onClick) => R.map((value) => formatMenuItem(value, onClick))

const getCountString = (pageSize, page, count) => {
  const startingCount = pageSize * (page - 1) + 1
  let remainingCount = pageSize * page
  remainingCount = count < remainingCount
    ? count
    : remainingCount

  return `${startingCount}-${remainingCount} of ${count}`
}

const TableNavigation = props => {
  const {
    styles,
    incrementPage,
    decrementPage,
    changePageSize,
    pageSize,
    page,
    count,
    isLastPage,
    isFirstPage,
    pageOptions
  } = props

  return (
    <Flex
      styleName='tableNavigation'
      align='center'
      justify='flex-end'
    >
      <span>Rows per page:</span>
      <span styleName='rowSize'>{pageSize}</span>
      <IconMenu icon='arrow_drop_down' position='topRight'>
        { getMenuItem(changePageSize)(pageOptions) }
      </IconMenu>
      <span styleName='pageSize'>
        { getCountString(pageSize, page, count) }
      </span>
      <div styleName='leftChevron'>
        <IconButton
          theme={styles}
          icon='chevron_left'
          onClick={decrementPage}
          disabled={isFirstPage}
        />
      </div>
      <div styleName='rightChevron'>
        <IconButton
          theme={styles}
          icon='chevron_right'
          onClick={incrementPage}
          disabled={isLastPage}
        />
      </div>
    </Flex>
  )
}

TableNavigation.propTypes = {
  pageSize: PropTypes.number.isRequired,
  page: PropTypes.number.isRequired,
  count: PropTypes.number.isRequired,
  isLastPage: PropTypes.bool.isRequired,
  isFirstPage: PropTypes.bool.isRequired,
  pageOptions: PropTypes.array.isRequired,
  incrementPage: PropTypes.func,
  decrementPage: PropTypes.func,
  changePageSize: PropTypes.func,
}

TableNavigation.defaultProps = {
  pageSize: 0,
  page: 0,
  count: 0,
  isLastPage: false,
  isFirstPage: false,
  pageOptions: []
}

export default TableNavigation
